import { LogoutButton } from './LogoutButton'
import { LinkButton } from './LinkButton'

interface PageHeaderProps {
  title: string
  showLogout?: boolean
  backTo?: string
  backLabel?: string
  navigationTo?: string
  navigationLabel?: string
}

export function PageHeader({
  title,
  showLogout = false,
  backTo,
  backLabel = '← Back',
  navigationTo,
  navigationLabel,
}: PageHeaderProps) {
  return (
    <header className="bg-slate-800 shadow-lg sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-3 md:space-x-8">
            <h1 className="text-lg md:text-xl font-bold text-white">{title}</h1>
            {navigationTo && navigationLabel && (
              <LinkButton to={navigationTo}>{navigationLabel}</LinkButton>
            )}
          </div>
          <div className="flex items-center space-x-3">
            {backTo && <LinkButton to={backTo}>{backLabel}</LinkButton>}
            {showLogout && <LogoutButton />}
          </div>
        </div>
      </div>
    </header>
  )
}
